var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFortuneIconL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6l-2 2v1.671L16.828 8.5H14v2.828l.672.672H13l-2 2 2 2h13l2-2-2-2h-.672l.672-.672V8.5h-2.828L22 9.67V8l-2-2zm-1 18v10h2V24h9v10H10V24h9zm12-2H21v-4h10v4zM9 18h10v4H9v-4z",
    fill: "#fff"
  })));
}

export default SvgFortuneIconL;